// src/contract-filter/contract-filterable-fields.ts
var CONTRACT_FILTERABLE_FIELDS = Object.freeze({
  STATUS: "status",
  CUSTOMER_NAME: "customer.name",
  PLAN_NAME: "plan.name",
  START_DATE: "startDate",
  END_DATE: "endDate",
  CREATED_AT: "createdAt",
  UPDATED_AT: "updatedAt",
  AUTO_RENEWAL: "plan.billingData.autoRenewal",
  CURRENCY: "customer.settings.currency",
  SYNC_STATUS: "integrationEntities.0.syncStatus",
  SIGNATURE_DATE: "signatureDate",
  CUSTOMER_ID: "customer.id",
  BILLING_INTERVAL: "plan.billingData.billingInterval",
  PLAN_DURATION: "plan.billingData.duration",
  LABELS: "labelIds"
});

// src/contract-filter/contract-filter-schema.ts
import { oz as oz14 } from "@vy/oz";

// src/contract-filter/contract-filter-schemas/contract-status-filter-schema.ts
import { oz } from "@vy/oz";
import { EnumFilterInputSchema } from "@vy/query-specifications-types";
import { CONTRACT_STATUSES } from "@vy/types";
var ContractStatusFieldPathSchema = oz.literal(CONTRACT_FILTERABLE_FIELDS.STATUS);
var ContractStatusFilterSchema = EnumFilterInputSchema.extend({
  field: ContractStatusFieldPathSchema,
  value: oz.union([oz.nativeEnum(CONTRACT_STATUSES), oz.array(oz.nativeEnum(CONTRACT_STATUSES))])
}).openapi("ContractStatusFilter");

// src/contract-filter/contract-filter-schemas/contract-customer-name-filter-schema.ts
import { oz as oz2 } from "@vy/oz";
import { StringFilterInputSchema } from "@vy/query-specifications-types";
var ContractCustomerNameFieldPathSchema = oz2.literal(CONTRACT_FILTERABLE_FIELDS.CUSTOMER_NAME);
var ContractCustomerNameValueSchema = oz2.union([oz2.string(), oz2.array(oz2.string())]);
var ContractCustomerNameFilterSchema = StringFilterInputSchema.extend({
  field: ContractCustomerNameFieldPathSchema,
  value: ContractCustomerNameValueSchema
}).openapi("ContractCustomerNameFilter");

// src/contract-filter/contract-filter-schemas/contract-name-filter-schema.ts
import { oz as oz3 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema2 } from "@vy/query-specifications-types";
var ContractNameFieldPathSchema = oz3.literal(CONTRACT_FILTERABLE_FIELDS.PLAN_NAME);
var ContractNameValueSchema = oz3.union([oz3.string(), oz3.array(oz3.string())]);
var ContractNameFilterSchema = StringFilterInputSchema2.extend({
  field: ContractNameFieldPathSchema,
  value: ContractNameValueSchema
}).openapi("ContractNameFilter");

// src/contract-filter/contract-filter-schemas/contract-start-date-filter-schema.ts
import { oz as oz4 } from "@vy/oz";
import { DateFilterInputSchema } from "@vy/query-specifications-types";
var ContractStartDateFieldPathSchema = oz4.literal(CONTRACT_FILTERABLE_FIELDS.START_DATE);
var ContractStartDateValueSchema = oz4.union([oz4.string().datetime(), oz4.array(oz4.string().datetime())]);
var ContractStartDateFilterSchema = DateFilterInputSchema.extend({
  field: ContractStartDateFieldPathSchema,
  value: ContractStartDateValueSchema
}).openapi("ContractStartDateFilter");

// src/contract-filter/contract-filter-schemas/contract-end-date-filter-schema.ts
import { oz as oz5 } from "@vy/oz";
import { DateFilterInputSchema as DateFilterInputSchema2 } from "@vy/query-specifications-types";
var ContractEndDateFieldPathSchema = oz5.literal(CONTRACT_FILTERABLE_FIELDS.END_DATE);
var ContractEndDateValueSchema = oz5.union([oz5.string().datetime(), oz5.array(oz5.string().datetime())]);
var ContractEndDateFilterSchema = DateFilterInputSchema2.extend({
  field: ContractEndDateFieldPathSchema,
  value: ContractEndDateValueSchema
}).openapi("ContractEndDateFilter");

// src/contract-filter/contract-filter-schemas/contract-auto-renewal-filter-schema.ts
import { oz as oz6 } from "@vy/oz";
import { BooleanFilterInputSchema } from "@vy/query-specifications-types";
var ContractAutoRenewalFieldPathSchema = oz6.literal(CONTRACT_FILTERABLE_FIELDS.AUTO_RENEWAL);
var ContractAutoRenewalValueSchema = oz6.union([oz6.boolean(), oz6.array(oz6.boolean())]);
var ContractAutoRenewalFilterSchema = BooleanFilterInputSchema.extend({
  field: ContractAutoRenewalFieldPathSchema,
  value: ContractAutoRenewalValueSchema
}).openapi("ContractAutoRenewalFilter");

// src/contract-filter/contract-filter-schemas/contract-currency-filter-schema.ts
import { oz as oz7 } from "@vy/oz";
import { EnumFilterInputSchema as EnumFilterInputSchema2 } from "@vy/query-specifications-types";
import { CURRENCIES } from "@vy/types";
var ContractCurrencyFieldPathSchema = oz7.literal(CONTRACT_FILTERABLE_FIELDS.CURRENCY);
var ContractCurrencyFilterSchema = EnumFilterInputSchema2.extend({
  field: ContractCurrencyFieldPathSchema,
  value: oz7.union([oz7.nativeEnum(CURRENCIES), oz7.array(oz7.nativeEnum(CURRENCIES))])
}).openapi("ContractCurrencyFilter");

// src/contract-filter/contract-filter-schemas/contract-sync-status-filter-schema.ts
import { oz as oz8 } from "@vy/oz";
import { EnumFilterInputSchema as EnumFilterInputSchema3 } from "@vy/query-specifications-types";
import { SYNC_STATUSES } from "@vy/types";
var ContractSyncStatusFieldPathSchema = oz8.literal(CONTRACT_FILTERABLE_FIELDS.SYNC_STATUS);
var ContractSyncStatusFilterSchema = EnumFilterInputSchema3.extend({
  field: ContractSyncStatusFieldPathSchema,
  value: oz8.union([oz8.nativeEnum(SYNC_STATUSES), oz8.array(oz8.nativeEnum(SYNC_STATUSES))])
}).openapi("ContractSyncStatusFilter");

// src/contract-filter/contract-filter-schemas/contract-signature-date-filter-schema.ts
import { oz as oz9 } from "@vy/oz";
import { DateFilterInputSchema as DateFilterInputSchema3 } from "@vy/query-specifications-types";
var ContractSignatureDateFieldPathSchema = oz9.literal(CONTRACT_FILTERABLE_FIELDS.SIGNATURE_DATE);
var ContractSignatureDateValueSchema = oz9.union([oz9.string().datetime(), oz9.array(oz9.string().datetime())]);
var ContractSignatureDateFilterSchema = DateFilterInputSchema3.extend({
  field: ContractSignatureDateFieldPathSchema,
  value: ContractSignatureDateValueSchema
}).openapi("ContractSignatureDateFilter");

// src/contract-filter/contract-filter-schemas/contract-customer-id-filter-schema.ts
import { oz as oz10 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema3 } from "@vy/query-specifications-types";
var ContractCustomerIdFieldPathSchema = oz10.literal(CONTRACT_FILTERABLE_FIELDS.CUSTOMER_ID);
var ContractCustomerIdValueSchema = oz10.union([oz10.string(), oz10.array(oz10.string())]);
var ContractCustomerIdFilterSchema = StringFilterInputSchema3.extend({
  field: ContractCustomerIdFieldPathSchema,
  value: ContractCustomerIdValueSchema
}).openapi("ContractCustomerIdFilter");

// src/contract-filter/contract-filter-schemas/contract-billing-interval-filter-schema.ts
import { oz as oz11 } from "@vy/oz";
import { NumberFilterInputSchema } from "@vy/query-specifications-types";
var ContractBillingIntervalFieldPathSchema = oz11.literal(CONTRACT_FILTERABLE_FIELDS.BILLING_INTERVAL);
var ContractBillingIntervalValueSchema = oz11.union([oz11.number(), oz11.array(oz11.number())]);
var ContractBillingIntervalFilterSchema = NumberFilterInputSchema.extend({
  field: ContractBillingIntervalFieldPathSchema,
  value: ContractBillingIntervalValueSchema
}).openapi("ContractBillingIntervalFilter");

// src/contract-filter/contract-filter-schemas/contract-plan-duration-filter-schema.ts
import { oz as oz12 } from "@vy/oz";
import { NumberFilterInputSchema as NumberFilterInputSchema2 } from "@vy/query-specifications-types";
var ContractPlanDurationFieldPathSchema = oz12.literal(CONTRACT_FILTERABLE_FIELDS.PLAN_DURATION);
var ContractPlanDurationValueSchema = oz12.union([oz12.number(), oz12.array(oz12.number())]);
var ContractPlanDurationFilterSchema = NumberFilterInputSchema2.extend({
  field: ContractPlanDurationFieldPathSchema,
  value: ContractPlanDurationValueSchema
}).openapi("ContractPlanDurationFilter");

// src/contract-filter/contract-filter-schemas/contract-labels-filter-schema.ts
import { ArrayFilterInputSchema } from "@vy/query-specifications-types";
import { oz as oz13 } from "@vy/oz";
var ContractLabelsFieldPathSchema = oz13.literal(CONTRACT_FILTERABLE_FIELDS.LABELS);
var ContractLabelsFilterSchema = ArrayFilterInputSchema.extend({
  field: ContractLabelsFieldPathSchema,
  value: oz13.array(oz13.string())
}).openapi("ContractLabelsFilter");

// src/contract-filter/contract-filter-schema.ts
var ContractFilterSchema = oz14.union([
  ContractStatusFilterSchema,
  ContractCustomerNameFilterSchema,
  ContractNameFilterSchema,
  ContractStartDateFilterSchema,
  ContractEndDateFilterSchema,
  ContractAutoRenewalFilterSchema,
  ContractCurrencyFilterSchema,
  ContractSyncStatusFilterSchema,
  ContractSignatureDateFilterSchema,
  ContractCustomerIdFilterSchema,
  ContractBillingIntervalFilterSchema,
  ContractPlanDurationFilterSchema,
  ContractLabelsFilterSchema
]).openapi("ContractFilter");

// src/index.ts
import { CONTRACT_STATUSES as CONTRACT_STATUSES2, INTEGRATION_PROVIDERS, SYNC_STATUSES as SYNC_STATUSES2, BaseIntegrationEntitySchema } from "@vy/types";
import { z } from "zod";
var ExtractContractFromPdfTaskMetadataSchema = z.object({
  accountId: z.string(),
  userId: z.string(),
  s3Bucket: z.string(),
  s3Key: z.string(),
  fileName: z.string()
});
export {
  BaseIntegrationEntitySchema,
  CONTRACT_FILTERABLE_FIELDS,
  CONTRACT_STATUSES2 as CONTRACT_STATUSES,
  ContractAutoRenewalFieldPathSchema,
  ContractAutoRenewalFilterSchema,
  ContractBillingIntervalFieldPathSchema,
  ContractBillingIntervalFilterSchema,
  ContractCurrencyFieldPathSchema,
  ContractCurrencyFilterSchema,
  ContractCustomerIdFieldPathSchema,
  ContractCustomerIdFilterSchema,
  ContractCustomerNameFieldPathSchema,
  ContractCustomerNameFilterSchema,
  ContractEndDateFieldPathSchema,
  ContractEndDateFilterSchema,
  ContractFilterSchema,
  ContractLabelsFieldPathSchema,
  ContractLabelsFilterSchema,
  ContractNameFieldPathSchema,
  ContractNameFilterSchema,
  ContractPlanDurationFieldPathSchema,
  ContractPlanDurationFilterSchema,
  ContractSignatureDateFieldPathSchema,
  ContractSignatureDateFilterSchema,
  ContractStartDateFieldPathSchema,
  ContractStartDateFilterSchema,
  ContractStatusFieldPathSchema,
  ContractStatusFilterSchema,
  ContractSyncStatusFieldPathSchema,
  ContractSyncStatusFilterSchema,
  ExtractContractFromPdfTaskMetadataSchema,
  INTEGRATION_PROVIDERS,
  SYNC_STATUSES2 as SYNC_STATUSES
};
